"use client";

import { c as _c } from "react/compiler-runtime";
import { useElementOnScreen } from "@/hooks/useElementOnScreen";
import { clsx } from "clsx";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { useTranslations } from "next-intl";
import NextImage from "next/image";
import { useCallback, useEffect, useRef, useState } from "react";
const realisations = [{
  image: "/images/realisations/realisation-sejour-contemporain.jpeg",
  index: 0
}, {
  image: "/images/realisations/realisation-salle-d-eau.jpg",
  index: 1
}, {
  image: "/images/realisations/realisation-terrasse.jpg",
  index: 2
}, {
  image: "/images/realisations/realisation-transformation-garage.jpg",
  index: 3
}, {
  image: "/images/realisations/realisation-suite-parentale.jpg",
  index: 4
}, {
  image: "/images/realisations/realisation-meuble-tv.jpg",
  index: 5
}, {
  image: "/images/realisations/realisation-cuisine-ouverte.jpg",
  index: 6
}, {
  image: "/images/realisations/realisation-cloture-bois.png",
  index: 7
}, {
  image: "/images/realisations/realisation-facade-hossegor.png",
  index: 8
}, {
  image: "/images/realisations/realisation-parement-pierre.jpg",
  index: 9
}, {
  image: "/images/realisations/realisation-metal-verre.jpg",
  index: 10
}, {
  image: "/images/realisations/realisation-interieur-gillet.jpg",
  index: 11
}];
export function Realisations() {
  const $ = _c(78);
  const {
    containerRef,
    isVisible
  } = useElementOnScreen();
  const t = useTranslations("realisations");
  const [lightboxImage, setLightboxImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerView, setItemsPerView] = useState(1);
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const updateItemsPerView = () => {
        if (window.innerWidth >= 1024) {
          setItemsPerView(6);
        } else {
          if (window.innerWidth >= 768) {
            setItemsPerView(4);
          } else {
            setItemsPerView(2);
          }
        }
      };
      updateItemsPerView();
      window.addEventListener("resize", updateItemsPerView);
      return () => window.removeEventListener("resize", updateItemsPerView);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const maxIndex = Math.max(0, Math.ceil(realisations.length / itemsPerView) - 1);
  let t2;
  if ($[2] !== maxIndex) {
    t2 = () => {
      setCurrentIndex(prev => prev >= maxIndex ? 0 : prev + 1);
    };
    $[2] = maxIndex;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const next = t2;
  let t3;
  if ($[4] !== maxIndex) {
    t3 = () => {
      setCurrentIndex(prev_0 => prev_0 <= 0 ? maxIndex : prev_0 - 1);
    };
    $[4] = maxIndex;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const prev_1 = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e => {
      touchStartX.current = e.targetTouches[0].clientX;
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleTouchStart = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e_0 => {
      touchEndX.current = e_0.targetTouches[0].clientX;
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleTouchMove = t5;
  let t6;
  if ($[8] !== next || $[9] !== prev_1) {
    t6 = () => {
      if (!touchStartX.current || !touchEndX.current) {
        return;
      }
      const distance = touchStartX.current - touchEndX.current;
      if (Math.abs(distance) > 50) {
        if (distance > 0) {
          next();
        } else {
          prev_1();
        }
      }
      touchStartX.current = null;
      touchEndX.current = null;
    };
    $[8] = next;
    $[9] = prev_1;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const handleTouchEnd = t6;
  let t7;
  if ($[11] !== next || $[12] !== prev_1) {
    t7 = () => {
      const handleKeyDown = e_1 => {
        if (e_1.key === "Escape") {
          setLightboxImage(null);
        }
        if (e_1.key === "ArrowRight") {
          next();
        }
        if (e_1.key === "ArrowLeft") {
          prev_1();
        }
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    };
    $[11] = next;
    $[12] = prev_1;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== lightboxImage || $[15] !== maxIndex || $[16] !== next || $[17] !== prev_1) {
    t8 = [lightboxImage, maxIndex, next, prev_1];
    $[14] = lightboxImage;
    $[15] = maxIndex;
    $[16] = next;
    $[17] = prev_1;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  useEffect(t7, t8);
  const t9 = isVisible && "visible";
  let t10;
  if ($[19] !== t9) {
    t10 = clsx("fade-in-up mb-16 flex flex-col md:flex-row md:items-end justify-between gap-6", t9);
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("title");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = <h2 className="text-4xl md:text-5xl font-serif text-forest-green mb-4">{t11}</h2>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="line-accent" />;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12) {
    t14 = <div>{t12}{t13}</div>;
    $[26] = t12;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t) {
    t15 = t("navigation.previous");
    $[28] = t;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <ChevronLeft size={24} />;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== prev_1 || $[32] !== t15) {
    t17 = <button onClick={prev_1} className="w-12 h-12 rounded-full border border-forest-green/20 flex items-center justify-center text-forest-green hover:bg-forest-green hover:text-white transition-all" aria-label={t15}>{t16}</button>;
    $[31] = prev_1;
    $[32] = t15;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t) {
    t18 = t("navigation.next");
    $[34] = t;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <ChevronRight size={24} />;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== next || $[38] !== t18) {
    t20 = <button onClick={next} className="w-12 h-12 rounded-full border border-forest-green/20 flex items-center justify-center text-forest-green hover:bg-forest-green hover:text-white transition-all" aria-label={t18}>{t19}</button>;
    $[37] = next;
    $[38] = t18;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t17 || $[41] !== t20) {
    t21 = <div className="hidden md:flex gap-4">{t17}{t20}</div>;
    $[40] = t17;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t10 || $[44] !== t14 || $[45] !== t21) {
    t22 = <div className={t10}>{t14}{t21}</div>;
    $[43] = t10;
    $[44] = t14;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  const t23 = `translateX(-${currentIndex * 100}%)`;
  let t24;
  if ($[47] !== t23) {
    t24 = {
      transform: t23
    };
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== maxIndex) {
    t25 = Array.from({
      length: maxIndex + 1
    });
    $[49] = maxIndex;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== isVisible || $[52] !== itemsPerView || $[53] !== t || $[54] !== t25) {
    t26 = <div className="flex">{t25.map((_, pageIndex) => <div key={pageIndex} className="w-full flex-shrink-0"><div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 auto-rows-fr">{realisations.slice(pageIndex * itemsPerView, pageIndex * itemsPerView + itemsPerView).map((project, index) => {
            const projectData = t.raw(`projects.${project.index}`);
            const fullTitle = `${projectData.title} - ${projectData.location}`;
            return <div key={`${project.index}-${index}`} className={clsx("scale-in card-hover group/item relative overflow-hidden rounded-xl aspect-[4/3] cursor-pointer", isVisible && "visible")} style={{
              transitionDelay: `${index % 3 * 100}ms`
            }} onClick={() => project.image && setLightboxImage({
              src: project.image,
              title: fullTitle
            })}><div className="absolute inset-0">{project.image && <NextImage src={project.image} alt={fullTitle} fill={true} loading="lazy" className="object-cover group-hover/item:scale-110 transition-transform duration-500" sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw" />}</div><div className="absolute inset-0 bg-charcoal/40 group-hover/item:bg-charcoal/60 transition-colors duration-300" /><div className="absolute inset-0 flex flex-col justify-end p-6 text-white-cream"><p className="text-terracotta-light text-sm mb-1 uppercase tracking-wider">{projectData.category}</p><h3 className="text-xl font-serif">{projectData.title}<span className="text-sm font-normal">{" "}- {projectData.location}</span></h3></div></div>;
          })}</div></div>)}</div>;
    $[51] = isVisible;
    $[52] = itemsPerView;
    $[53] = t;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== handleTouchEnd || $[57] !== t24 || $[58] !== t26) {
    t27 = <div className="relative overflow-hidden"><div className="transition-transform duration-500 ease-in-out" style={t24} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>{t26}</div></div>;
    $[56] = handleTouchEnd;
    $[57] = t24;
    $[58] = t26;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] !== maxIndex) {
    t28 = Array.from({
      length: maxIndex + 1
    });
    $[60] = maxIndex;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== currentIndex || $[63] !== t || $[64] !== t28) {
    t29 = <div className="mt-12 flex justify-center gap-2">{t28.map((__0, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={clsx("w-2 h-2 rounded-full transition-all", currentIndex === idx ? "w-6 bg-forest-green" : "bg-forest-green/20")} aria-label={`${t("navigation.goToPage")} ${idx + 1}`} />)}</div>;
    $[62] = currentIndex;
    $[63] = t;
    $[64] = t28;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== t22 || $[67] !== t27 || $[68] !== t29) {
    t30 = <div className="max-w-7xl mx-auto px-6">{t22}{t27}{t29}</div>;
    $[66] = t22;
    $[67] = t27;
    $[68] = t29;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  let t31;
  if ($[70] !== containerRef || $[71] !== t30) {
    t31 = <section id="realisations" ref={containerRef} className="py-24 bg-sand-light overflow-hidden">{t30}</section>;
    $[70] = containerRef;
    $[71] = t30;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  let t32;
  if ($[73] !== lightboxImage) {
    t32 = lightboxImage && <div className="fixed inset-0 z-50 bg-charcoal/95 backdrop-blur-md flex items-center justify-center p-4 cursor-pointer" onClick={() => setLightboxImage(null)} role="dialog" aria-modal="true"><button className="absolute top-6 right-6 z-10 w-12 h-12 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-terracotta transition-colors" onClick={e_2 => {
        e_2.stopPropagation();
        setLightboxImage(null);
      }}><X size={24} /></button><div className="relative max-w-6xl max-h-[90vh] w-full h-full flex flex-col" onClick={_temp}><div className="relative flex-1"><NextImage src={lightboxImage.src} alt={lightboxImage.title} fill={true} className="object-contain" sizes="100vw" /></div><div className="bg-charcoal/40 backdrop-blur-sm p-6 text-center"><h3 className="text-white text-2xl font-serif">{lightboxImage.title}</h3></div></div></div>;
    $[73] = lightboxImage;
    $[74] = t32;
  } else {
    t32 = $[74];
  }
  let t33;
  if ($[75] !== t31 || $[76] !== t32) {
    t33 = <>{t31}{t32}</>;
    $[75] = t31;
    $[76] = t32;
    $[77] = t33;
  } else {
    t33 = $[77];
  }
  return t33;
}
function _temp(e_3) {
  return e_3.stopPropagation();
}